import { toast } from 'react-toastify';
import { getErrorMessage } from './toastMessages';
export var showSuccessToast = function (message) {
    toast.success(message);
};
export var showErrorToast = function (error, defaultMessage) {
    var message = getErrorMessage(error, defaultMessage);
    toast.error(message);
};
export var showInfoToast = function (message) {
    toast.info(message);
};
export var showWarningToast = function (message) {
    toast.warning(message);
};
